import CdnBackgroundImage from 'components/CdnBackgroundImage'
import PromotionLink from 'components/PromotionLink'
import { useTranslation } from 'helpers/hooks/useTranslation'
import { getImageUrl } from 'helpers/image'
import React from 'react'
import Story from 'store/entities/Story/Story.store'
import styled, { css } from 'styled-components'
import { complementaryColor } from 'uiComponents/constants/colors'
import { fwHeavy, fwMediumBold } from 'uiComponents/constants/typography'

const fillBrowseViewportHeight = css`
  height: 65vh;
  height: calc(100vh - var(--layout-header-show-more-height, 10vh));
  min-height: 375px;
`
const fullAbsolute = css`
  position: absolute;
  width: 100%;
  height: 100%;
`
const TopGradient = styled.div`
  ${fullAbsolute};
  opacity: 0.4;
  background-image: linear-gradient(to top, #000, rgba(0, 0, 0, 0) 81%);
  top: 0;
`
const BottomGradient = styled.div`
  ${fullAbsolute};
  opacity: 0.35;
  background-image: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.53),
    rgba(0, 0, 0, 0) 39%,
    rgba(0, 0, 0, 0) 39%
  );
  bottom: 0;
`
const StyledCdnBackgroundImage = styled(CdnBackgroundImage)`
  width: 100%;
  height: 100%;
  z-index: 1;
  background-size: cover;
  background-position: top;
`

const PremiumHeadline = styled.div`
  color: ${complementaryColor};
  font-size: 65px;
  line-height: 70px;
  ${fwMediumBold}
  text-transform: uppercase;
  max-width: 500px;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-bottom: 60px;
  margin-left: -2px;
`

const PremiumSubline = styled.div`
  color: ${complementaryColor};
  font-size: 12px;
  ${fwHeavy}
  text-transform: uppercase;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-bottom: 7px;
`

const PremiumProductsDiscover = styled.span`
  color: ${complementaryColor};
  border-bottom: 1px solid ${complementaryColor};
  padding-bottom: 7px;
`

const Container = styled.div`
  ${fillBrowseViewportHeight}
  position: relative;
`

const ContentContainer = styled.div`
  position: absolute;
  left: 10%;
  top: 50%;
  transform: translateY(-50%);
`

interface Props {
  story: Story
}

const PremiumHeroSlide: React.FC<Props> = ({ story }) => {
  const { t } = useTranslation()
  const imageUrl = getImageUrl(story.image, { width: 2000, height: 2000 })

  return (
    <Container>
      <PromotionLink to={story.url}>
        <StyledCdnBackgroundImage
          imageHash={imageUrl || ''}
          preload={true}
          width={2000}
          height={2000}
        >
          <TopGradient />
          <ContentContainer>
            <PremiumSubline>{story.subline}</PremiumSubline>
            <PremiumHeadline>{story.headline}</PremiumHeadline>
            <PremiumProductsDiscover>
              {t('Produkte entdecken')}
            </PremiumProductsDiscover>
          </ContentContainer>
          <BottomGradient />
        </StyledCdnBackgroundImage>
      </PromotionLink>
    </Container>
  )
}

export default PremiumHeroSlide
